import React from 'react';

import { Icon } from '../icons';

export const SwipingCardsIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 14 14" stroke={color} style={style} fill="none">
      <g>
        <path
          d="M5.71986 6.09325L2.73877 6.24948L3.0304 11.8142L8.5951 11.5225L8.52219 10.1314"
          strokeWidth="0.65625"
          strokeLinejoin="round"
        />
        <rect
          x="6.48096"
          y="3.0625"
          width="6.5625"
          height="6.5625"
          transform="rotate(10 6.48096 3.0625)"
          strokeWidth="0.65625"
          strokeLinejoin="round"
        />
        <path
          d="M5.17662 1.98624C4.3657 1.65757 2.41518 1.81115 1.75783 3.433C1.64923 3.70095 1.58505 3.95469 1.55996 4.1942"
          strokeWidth="0.65625"
          strokeLinecap="round"
        />
        <path
          d="M4.27804 3.0383L5.37924 2.06842L4.49152 0.764485"
          strokeWidth="0.65625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
